<div class="container-fluid" style="padding: 0; overflow: hidden;">
  <div class="row">
    <div class="col-md-12 d-flex" alt="Immagine di login" id="background-image">
    </div>
    <div class="col-md-12 d-flex login_style justify-content-center">
      <div class="col-md-6">
        <form [formGroup]="formLogin">
          <div class="center-container mt-0" style="border-radius: 0.5rem;">
            <div style="background-color: white;">
              <div class="col-md-12 d-flex flex-column align-items-start px-4 mt-4">
                <div style="width: 15rem; height: auto;">
                  <img src="../../../assets/images/Logo-OG.png">
                </div>
                <div class="mt-4 justify-content-center align_style d-flex justify-content-center">
                  <div style="width: 75%; text-align: center;">
                    <img src="../../../assets/images/LOGO_FIGURINO.png">
                  </div>
                </div>
                <div class="mt-3 align_style">
                  <a style="color: #199C72; font-weight: 600; font-size: 1.25rem;">{{
                    'InsertANewPassword' | translate }}</a>
                </div>
                <div class="mt-4 d-flex flex-column justify-content-start"
                  style="width: 100%; padding-left: 5rem; padding-right: 5rem; height: 7rem;">
                  <div style="font-weight: 400; font-size: 1.3125rem">
                    {{ 'Password' | translate }}
                  </div>
                  <div class="col-md-12 d-flex flex-wrap mt-2">
                    <input class="input_style w-100 col-md-12 form-control" type="password" id="password" name="password"
                      formControlName="password" placeholder="{{ 'InsertPassword' | translate }}" [ngClass]="{
                                          'is-valid': isOnSubmit && formLogin.get('password').valid,
                                          'is-invalid': isOnSubmit && formLogin.get('password').invalid }">
                    <span class="text-danger" *ngIf="formLogin.get('password').hasError('pattern') && isOnSubmit">
                      {{ 'RequiredFields.PasswordRequirements' | translate }}
                    </span>
                    <span class="text-danger"
                      *ngIf="formLogin.get('password').hasError('minlength') && isOnSubmit && !formLogin.get('password').hasError('pattern')">
                      {{ 'RequiredFields.MinLengthPassword' | translate }} {{
                      formLogin.get('password').errors?.minlength.requiredLength }} {{ 'RequiredFields.Characters' |
                      translate }}
                    </span>
                    <span class="text-danger"
                      *ngIf="formLogin.get('password').hasError('maxlength') && isOnSubmit && !formLogin.get('password').hasError('pattern')">
                      {{ 'RequiredFields.MaxLengthPassword' | translate }}{{
                      formLogin.get('password').errors?.maxlength.requiredLength }} {{ 'RequiredFields.Characters' |
                      translate }}
                    </span>
                  </div>
                </div>
                <div class="mt-4 d-flex flex-column justify-content-start"
                  style="width: 100%; padding-left: 5rem; padding-right: 5rem; height: 7rem;">
                  <div style="font-weight: 400; font-size: 1.3125rem">
                    {{ 'ConfirmPassword' | translate }}
                  </div>
                  <div class="col-md-12 d-flex flex-wrap mt-2">
                    <input class="input_style w-100 col-md-12 form-control" type="password" id="password_confirm"
                      name="password_confirm" formControlName="password_confirm"
                      placeholder="{{ 'InsertPassword' | translate }}" [ngClass]="{
                                          'is-valid': isOnSubmit && formLogin.get('password_confirm').valid,
                                          'is-invalid': isOnSubmit && formLogin.get('password_confirm').invalid }">
                    <span class="text-danger" *ngIf="(formLogin.get('password_confirm').hasError('passwordMismatch'))
                    && isOnSubmit">
                      {{ 'RequiredFields.PasswordsDoNotMatch' | translate }}
                    </span>
                  </div>
                </div>
                <div class="mt-5 d-flex justify-content-center"
                  style="padding-left: 5rem; padding-right: 5rem; width: 100%">
                  <button class="btn btn_login" (click)="onSubmit()" [disabled]="isDisabled">
                    {{ 'SendU' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>